export default {
  isNumber: /(^[\-0-9][0-9]*(.[0-9]+)?)$/,// 是否是数字
  isPhone: /^1\d{10}$/, // 是否电话号码
  isEmil: /^([a-zA-Z]|[0-9])(\w|\-|\.)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
  // isEmil: /^\w+(?:\.\w+){0,1}@[a-zA-Z0-9]{2,14}(?:\.[a-z]{2,4}){1,2}$/,// 是否邮箱
  isEnglish: /^[a-zA-Z]+$/,// 是否英文字母
  isChinese: /^[\u4e00-\u9fa5]+$/,// 是否是中文
  isChar: /^[@#$!~,，￥*&()`~?]+$/, // 仅限@$^!~,.* 是否是特殊字符
  isNumberStr: '(^[\-0-9][0-9]*(.[0-9]+)?)$',// 是否是数字
  isPhoneStr: '^1\d{10}$', // 是否电话号码
  isEmilStr: '^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$',// 是否邮箱
  isEnglishStr: '^[a-zA-Z]+$',// 是否英文字母
  isChineseStr: '^[\u4e00-\u9fa5]+$',// 是否是中文
  isCharStr: '^(?=.*\d)(?=.*[a-zA-Z])(?=.*[@$^!~,.*])[\da-zA-z@$^!~,.*]{8,16}$', // 仅限@$^!~,.* 是否是特殊字符

  searchNumber: /[\-0-9][0-9]*(.[0-9]+)?/,
  searchEnglish: /[a-zA-Z]/,
  searchChinese: /[\u4e00-\u9fa5]/,
  searchChar: /[@#$!~,，￥*&()`~?]/,

  ne: /^(([\-0-9][0-9]*(.[0-9]+)?)*|[a-zA-Z]*)+$/, // 数字英文
  nc: /^(([\-0-9][0-9]*(.[0-9]+)?)*|[\u4e00-\u9fa5]*)+$/, // 数字汉语
  ec: /^([a-zA-Z]*|[\u4e00-\u9fa5]*)+$/, // 英文汉语
  nec: /^(([\-0-9][0-9]*(.[0-9]+)?)*|[a-zA-Z]*|[\u4e00-\u9fa5]*)+$/ // 数字英文汉字
}
